import { createFileRoute, Outlet } from '@tanstack/react-router'
import BottomBar from '@/components/features/paytm/bottom-nav-bar'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'
import { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { LoginApiResponse } from '@/lib/interfaces'
import { Api } from '@/lib/utils'
import Login from '@/components/features/login'

export const Route = createFileRoute('/paytm')({
  component: RouteComponent,
})

function RouteComponent() {
  const { setPaytmTab, paytmTab, token, phoneNumber, accountId, setLogin, loggedIn } = useStore(useShallow(state => ({
    paytmTab: state.paytmTab,
    setPaytmTab: state.setPaytmTab,
    token: state.token,
    phoneNumber: state.phoneNumber,
    accountId: state.selectedAccount.id,
    setLogin: state.setLogin,
    loggedIn: state.loggedIn,
  })))

  const [showPaytmVerification, setPaytmVerificationDisplay] = useState(false)

  const verifyPaytmLogin = useMutation({
    mutationFn: ({ authId, openId }: { authId: string, openId: string, callback: (data: LoginApiResponse) => void }) => {
      return Api<LoginApiResponse>('/webui/verifyPaytmAccount', "POST", { auth_id: authId, open_id: openId })
    },
    onError() {
      setPaytmVerificationDisplay(false)
    },
    onSuccess(data, variables) {
      variables.callback(data)
      setPaytmVerificationDisplay(false)
    },
  })

  const getBridgeData = () => {
    try {
      setPaytmVerificationDisplay(true);
      (window as any).JSBridge.call('paytmFetchAuthCode', {
        clientId: 'merchant-paytm-swift-prod'
      }, function (result: { error?: number, message?: string, data?: { authId: string, openId: string } }) {
        if (result.data) {
          verifyPaytmLogin.mutate({
            authId: result.data.authId, openId: result.data.openId, callback: (data) => {
              setLogin(data)
              setPaytmVerificationDisplay(false)
            }
          })
        } else {
          setPaytmVerificationDisplay(false)
        }
      });
    } catch {
      setPaytmVerificationDisplay(false)
    }
  }

  useEffect(() => {
    if (!loggedIn) {
      getBridgeData()
    }
  }, [])

  useEffect(() => {
    if (showPaytmVerification) {
      setTimeout(() => {
        setPaytmVerificationDisplay(false)
      }, 15000)
    }
  }, [showPaytmVerification])

  if (loggedIn) {
    return <div className='w-full'>
      <Outlet />
      <BottomBar selectedTab={paytmTab}
        selectTab={val => setPaytmTab(val)}
        token={token}
        phoneNumber={phoneNumber}
        accountId={accountId}
      />
    </div>
  } else if (showPaytmVerification) {
    return <div className='fixed left-0 right-0 top-0 bottom-0 flex items-center flex-col pt-40 text-sm'>
      <p className='text-lg'>Verifying Credentials</p>
      <p className='text-lg'>Please wait...</p>
    </div>
  } else {
    return <Login />
  }
}
